(function () {
  function initAshlionIppReviewsCarousel(rootEl) {
    const section = rootEl || document.querySelector("[data-ipp-reviews]");
    if (!section || section.dataset.carouselReady === "true") return;

    section.dataset.carouselReady = "true";

    const track = section.querySelector("[data-ipp-review-track]");
    const nextBtn = section.querySelector("[data-ipp-review-next]");
    const dotsWrap = section.querySelector("[data-ipp-review-dots]");

    if (!track || !nextBtn || !dotsWrap) return;

    const cards = Array.from(
      track.querySelectorAll(".ashlion-ipp-review")
    );

    if (cards.length < 2) return;

    const AUTO_MS = 5000;

    let autoTimer = null;
    let isVisible = true;
    let scrollRaf = null;

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* Pagination */
    cards.forEach(function (_, index) {
      const dot = document.createElement("button");

      dot.type = "button";
      dot.className =
        "ashlion-ipp-reviews__dot" +
        (index === 0 ? " is-active" : "");

      dot.setAttribute("aria-label", "Show review " + (index + 1));

      dot.addEventListener("click", function () {
        goTo(index);
        resetAutoRotate();
      });

      dotsWrap.appendChild(dot);
    });

    const dots = Array.from(
      dotsWrap.querySelectorAll(".ashlion-ipp-reviews__dot")
    );

    /* Position of card relative to first card */
    function cardPosition(index) {
      return cards[index].offsetLeft - cards[0].offsetLeft;
    }

    function getIndex() {
      let closest = 0;
      let smallestDistance = Infinity;

      cards.forEach(function (_, index) {
        const distance = Math.abs(
          track.scrollLeft - cardPosition(index)
        );

        if (distance < smallestDistance) {
          smallestDistance = distance;
          closest = index;
        }
      });

      return closest;
    }

    function updateDots() {
      const current = getIndex();

      dots.forEach(function (dot, index) {
        dot.classList.toggle("is-active", index === current);
      });
    }

    function goTo(index, smooth) {
      if (smooth === undefined) smooth = true;

      track.scrollTo({
        left: cardPosition(index),
        behavior:
          smooth && !prefersReducedMotion ? "smooth" : "auto",
      });
    }

    function goNext() {
      const current = getIndex();
      const next =
        current >= cards.length - 1 ? 0 : current + 1;

      goTo(next);
    }

    /* Auto rotate */
    function stopAutoRotate() {
      if (autoTimer) {
        clearTimeout(autoTimer);
        autoTimer = null;
      }
    }

    function scheduleNextTick() {
      stopAutoRotate();

      if (
        prefersReducedMotion ||
        !isVisible ||
        document.hidden
      ) {
        return;
      }

      autoTimer = setTimeout(function () {
        goNext();
        scheduleNextTick();
      }, AUTO_MS);
    }

    function resetAutoRotate() {
      stopAutoRotate();
      scheduleNextTick();
    }

    /* Events */
    nextBtn.addEventListener("click", function () {
      stopAutoRotate();
      goNext();
      scheduleNextTick();
    });

    track.addEventListener(
      "scroll",
      function () {
        if (scrollRaf) return;

        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          updateDots();
        });
      },
      { passive: true }
    );

    section.addEventListener("mouseenter", stopAutoRotate);
    section.addEventListener("mouseleave", scheduleNextTick);
    section.addEventListener("focusin", stopAutoRotate);
    section.addEventListener("focusout", scheduleNextTick);
    section.addEventListener("pointerdown", stopAutoRotate, {
      passive: true,
    });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stopAutoRotate();
      } else {
        scheduleNextTick();
      }
    });

    /* Only autoplay while visible */
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        function (entries) {
          isVisible =
            !!entries[0] && entries[0].isIntersecting;

          if (isVisible) {
            updateDots();
            scheduleNextTick();
          } else {
            stopAutoRotate();
          }
        },
        { rootMargin: "200px 0px" }
      );

      io.observe(section);
    }

    updateDots();
    scheduleNextTick();
  }

  window.initAshlionIppReviewsCarousel =
    initAshlionIppReviewsCarousel;

  function boot() {
    const section = document.querySelector("[data-ipp-reviews]");
    if (!section) return;

    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            io.disconnect();
            initAshlionIppReviewsCarousel(section);
          }
        },
        { rootMargin: "400px 0px" }
      );

      io.observe(section);
    } else {
      initAshlionIppReviewsCarousel(section);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();